/**
 * Cookie操作工具类
 * 提供Cookie的读取、设置和删除功能
 */
const CookieUtil = {
    /**
     * 设置Cookie
     * @param {string} name - Cookie名称
     * @param {string} value - Cookie值
     * @param {number} days - 有效天数，默认7天
     * @param {string} path - Cookie路径，默认为根路径
     */
    setCookie(name, value, days = 7, path = '/') {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=${path}; SameSite=Lax`;
    },
    
    /**
     * 获取Cookie
     * @param {string} name - Cookie名称
     * @returns {string} Cookie值，不存在则返回空字符串
     */
    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return decodeURIComponent(parts.pop().split(';').shift());
        }
        return '';
    },
    
    /**
     * 删除Cookie
     * @param {string} name - Cookie名称
     * @param {string} path - Cookie路径，默认为根路径
     */
    deleteCookie(name, path = '/') {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; SameSite=Lax`;
    }
};

export default CookieUtil; 